import { React, useState } from 'react';
import { Container, Card, CardTitle, CardBody, FormGroup, Input, Button, Alert, Label, Row, Col, Spinner } from 'reactstrap';

import { useApp } from 'src/appContext';

const Login = () => {
	const { login } = useApp();
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [status, setStatus] = useState('');
	const [message, setMessage] = useState('');

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (status === 'signing') return;
		if (!email || !password) {
			setStatus('error');
			return setMessage('Please enter your email and password.');
		}
		setStatus('signing');
		setMessage('');
		try {
			await login(email.trim(), password);
			// The app swaps this page for the home screen once authenticated.
		} catch (error) {
			setStatus('error');
			setMessage(error.message);
		}
	};

	return (
		<Container>
			{/* <Form className="login-form" onSubmit={handleSubmit}> */}
			<Row>
				<Col sm={{ offset: 3, size: 6 }}>
					<Card>
						<CardTitle style={{ textAlign: 'center' }}>
							<h2> My Activity Hub </h2>
							<hr />
						</CardTitle>
						<CardBody tag="form" onSubmit={handleSubmit}>
							<CardTitle tag="h5">Please sign in</CardTitle>
							<FormGroup>
								<Label for="email"> Email Address</Label>
								<Input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} />
							</FormGroup>
							<FormGroup>
								<Label for="password"> Password </Label>
								<Input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} />
							</FormGroup>
							<Button type="submit" color="info" block={true} disabled={status === 'signing'}>
								{status === 'signing' ? <Spinner /> : 'Sign In'}
							</Button>
							<br />
							{status === 'error' && message && <Alert color="danger">{message}</Alert>}
						</CardBody>
					</Card>
				</Col>
			</Row>
			{/* </Form> */}
		</Container>
	);
};

export default Login;
